function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.88,95.52C418.33,139.81,319.8,31.89,211.94,52.17,158.08,62.29,111.75,99.68,82,144.59c-31.88,48.1-47.92,110.84-27,166.49a144.1,144.1,0,0,0,25.2,42.41c61,71.76,190.61,111.05,279.4,74.55l1.23-.51c98.44-41.63,170.32,9.7,255.41-14.45,96-27.24,118.92-160.91,84.53-242-9.57-22.55-26.12-42.54-45.51-57.33C618.19,85.5,569.28,77.65,525.88,95.52Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.88,95.52C418.33,139.81,319.8,31.89,211.94,52.17,158.08,62.29,111.75,99.68,82,144.59c-31.88,48.1-47.92,110.84-27,166.49a144.1,144.1,0,0,0,25.2,42.41c61,71.76,190.61,111.05,279.4,74.55l1.23-.51c98.44-41.63,170.32,9.7,255.41-14.45,96-27.24,118.92-160.91,84.53-242-9.57-22.55-26.12-42.54-45.51-57.33C618.19,85.5,569.28,77.65,525.88,95.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.62,
    cy: 469.88,
    rx: 269.95,
    ry: 9.36,
    style: {
      fill: "#6C63FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Puzzle--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.32,454.35a46.62,46.62,0,0,1-12.84-1.85c-14.21-4.09-25.54-14.27-29.56-26.58-6.14-18.78,10.1-34.5,12-36.22,4.3-4,8.86-9.55,6.4-13.75-35.44-8.58-52.42-8.19-95.56-4.75l-.79.06.28-.74c3.48-9,9.06-23.13,15.86-38.86,11.15-25.8,12.42-51.23,3.48-69.78-1.44-3-2.92-4.61-4.5-4.91-2.53-.47-5.47,2.27-9.21,5.74-7,6.48-16.51,15.36-31.84,11.25-13.45-3.61-20.21-14.28-23.52-22.59-6-15.08-5.27-35,1.68-46.27,12.33-20,32.11-14.94,46.54-7.13,9.45,5.12,14.3,5.26,16.71,4.48a3.57,3.57,0,0,0,2-1.38c0-1.48-.34-16.11-5.56-52.63A337,337,0,0,0,379.49,89l-.26-.76.8.11c3.13.41,15.16,1.3,22.35,1.83l4.36.33c98.19,7.74,208.9,3.79,210,3.74l.72,0-.23.68c-.17.51-16.79,51.26-11.53,110.45,2.31,3.41,6,4,10.85,1.65.92-.43,1.86-.89,2.82-1.36,12.72-6.19,30.14-14.68,48.5,5.65,8.87,9.81,12,23.52,8.52,37.62-3.52,14.37-13.25,26.1-25.39,30.61h0c-17.4,6.45-32.85-6.91-36.18-10.07,11.63,65.21,30.06,143.52,30.25,144.31l.17.75-.75-.14c-.77-.14-77.09-14-111.75-23.09a15.72,15.72,0,0,0,1,3.1c.4.94.82,1.9,1.25,2.88,5.68,13,13.47,30.7-7.56,48.23A38.8,38.8,0,0,1,502.32,454.35Zm-77.06-86.44c17.54,0,32.18,1.95,53.48,7.12l.19,0,.11.17c2.46,3.86.28,9-6.47,15.19-1.82,1.69-17.65,17-11.7,35.18,3.92,12,15,21.93,28.88,25.93,13.63,3.91,27.13,1.43,37-6.83,20.45-17,13.15-33.69,7.28-47.06-.43-1-.85-1.95-1.25-2.89a16.06,16.06,0,0,1-1.18-4.1l-.1-.75.73.2c32.44,8.58,103.56,21.65,111.67,23.13-1.93-8.25-19.34-83-30.35-145.16l-.28-1.56,1.12,1.12c.24.23.42.42.62.6,1.76,1.77,17.66,17,35.62,10.33h0c11.83-4.4,21.32-15.86,24.77-29.91,3.37-13.77.35-27.15-8.29-36.71-17.86-19.77-34.19-11.81-47.32-5.42L617,207.9c-6.81,3.22-10.38.63-12.18-2.12l-.07-.1v-.13c-5-55.72,9.38-104,11.34-110.29-9.67.33-115.28,3.65-209.41-3.77l-4.36-.33c-6.69-.49-17.57-1.3-21.61-1.75a338.2,338.2,0,0,1,14.18,58.89c5.51,38.51,5.57,52.75,5.57,52.89l0,.2a4.23,4.23,0,0,1-2.59,2c-2.58.88-7.73.81-17.57-4.52-14.05-7.61-33.29-12.6-45.2,6.77-6.81,11.06-7.5,30.57-1.61,45.38,3.23,8.1,9.8,18.49,22.85,22,14.79,4,24.1-4.69,30.9-11,3.94-3.67,7.05-6.56,10.08-6,1.94.37,3.6,2.1,5.22,5.46,9.06,18.81,7.79,44.54-3.47,70.61-6.62,15.29-12.07,29-15.56,38.08C400.57,368.78,413.56,367.91,425.26,367.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.06,398.76c-50.16,0-89-9.27-89.6-9.43l-.56-.13.21-.53c.2-.51,20.1-51.27,24.31-126-2.59-1.55-5.58,1.49-9,5L143.13,269c-1.8,1.8-18.15,17.42-36.66,10.55-12.15-4.51-21.88-16.24-25.4-30.6-3.45-14.1-.35-27.82,8.52-37.63,18.35-20.32,35.77-11.84,48.49-5.65,1,.47,1.91.93,2.83,1.36,3.19,1.52,5.88,1.81,8,.86,2.53-1.12,3.82-3.87,4.46-6-3.58-77.22-15.75-99.57-15.87-99.79l-.36-.62.71-.12c.43-.07,43.39-6.92,96.1-11.65,2.16-.74,4.92-2.18,5.95-4.79.84-2.15.42-4.82-1.26-7.94q-.72-1.35-1.5-2.76C230.3,61.78,221,44.8,240.36,25.45c9.36-9.34,22.9-13.12,37.15-10.37C292,17.88,304.22,27,309.33,38.92c7.79,18.16-7,35.26-8.71,37.15-.41.46-.83.91-1.25,1.37-2.81,3-5.47,5.94-4.93,8.27,34.38-1.28,63.17-.4,85.59,2.62l.3,0,.1.29a337.82,337.82,0,0,1,14.44,59.64c5.51,38.51,5.57,52.75,5.57,52.89l0,.2a4.23,4.23,0,0,1-2.59,2c-2.58.88-7.73.81-17.57-4.52-14-7.61-33.29-12.6-45.2,6.77-6.81,11.06-7.5,30.57-1.61,45.38,3.23,8.1,9.8,18.49,22.85,22,14.79,4,24.1-4.69,30.9-11,3.94-3.67,7.05-6.56,10.08-6,1.94.37,3.6,2.1,5.22,5.46,9.06,18.81,7.79,44.54-3.47,70.61h0c-6.8,15.72-12.37,29.78-15.84,38.82l-.11.29-.32,0a279.43,279.43,0,0,0-66.05,13.26C284,395.36,249.44,398.76,219.06,398.76Zm-88.81-10.27c8.12,1.88,103.05,22.7,186.13-5a280.81,280.81,0,0,1,66-13.29c3.48-9.05,9-23,15.74-38.56,11.15-25.8,12.42-51.23,3.48-69.78-1.44-3-2.92-4.61-4.5-4.91-2.53-.47-5.47,2.27-9.21,5.74-7,6.48-16.51,15.36-31.84,11.25-13.45-3.61-20.21-14.28-23.52-22.59-6-15.08-5.27-35,1.68-46.27,12.33-20,32.11-14.94,46.54-7.13,9.45,5.12,14.3,5.26,16.71,4.48a3.57,3.57,0,0,0,2-1.38c0-1.48-.34-16.11-5.56-52.63a337,337,0,0,0-14.29-59.16c-22.4-3-51.16-3.85-85.5-2.56h-.36l-.12-.33c-1.13-3,1.86-6.21,5-9.64.41-.45.83-.9,1.24-1.36,1.67-1.84,16.08-18.49,8.53-36.08-5-11.61-16.89-20.52-31.09-23.26-13.92-2.69-27.13,1-36.25,10.1C222.21,45,231,60.9,238,73.69c.51.94,1,1.86,1.5,2.76,1.82,3.4,2.26,6.35,1.31,8.79s-3.22,4.23-6.62,5.39l-.11,0c-49.09,4.41-89.74,10.65-95.41,11.54,2,4.12,12.42,29.11,15.68,99.69V202l0,.08c-1,3.37-2.73,5.7-5,6.73s-5.35.77-8.82-.87l-2.84-1.37c-13.12-6.39-29.46-14.35-47.31,5.42-8.64,9.57-11.66,23-8.28,36.72,3.44,14.05,12.93,25.5,24.76,29.9,17.93,6.66,33.86-8.56,35.62-10.32l1.26-1.28c3.7-3.77,7.19-7.33,10.54-5l.22.16v.27C150.48,333.35,132.4,382.82,130.25,388.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.23,464.44a.4.4,0,0,0,.46-.26,48.89,48.89,0,0,0-10-46.61.4.4,0,0,0-.55,0,.38.38,0,0,0,0,.54A48.1,48.1,0,0,1,102,464a.38.38,0,0,0,.26.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.68,448.59c4.7-.35,6.5,7,6.32,7.13-.07.8-.16,1.61-.28,2.41-.22-1.06-2.13-2.92-5.4-4.3S93.2,448.75,97.68,448.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,448.21c4.62-.17,2.54,5.85-1.06,6.79s-5.84,2.24-6.42,3.14c.17-.79.32-1.59.44-2.4C104.4,455.83,106.91,448.54,111.27,448.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,441.65c4.57-1.12,7.58,5.77,7.43,5.89.06.79.11,1.59.13,2.39-.4-1-2.59-2.48-6-3.27S92.51,442.57,96.9,441.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23,439c4.52-.94,3.48,5.28.09,6.79s-5.37,3.16-5.79,4.14c0-.8,0-1.6,0-2.41C104.73,447.59,106,440.06,110.23,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,435c4.32-1.86,8.43,4.41,8.3,4.53.19.77.37,1.54.53,2.32-.57-.9-3-2-6.51-2.18S90.8,436.61,95,435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.68,430.13c4.3-1.68,4.3,4.61,1.22,6.66s-4.77,4-5,5c-.1-.79-.22-1.57-.36-2.36C103.68,439.5,103.67,431.89,107.68,430.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,428.7c4-2.56,9.06,2.95,9,3.09q.48,1.08.9,2.19c-.7-.79-3.26-1.46-6.77-1.05S88.12,431,92,428.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.67,421.8c4-2.38,5,3.84,2.32,6.37-2.56,2.58-4,4.74-4.11,5.79-.24-.76-.49-1.51-.76-2.26C101.31,431.72,100,424.21,103.67,421.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,423c3.46-3.19,9.46,1.43,9.37,1.58.44.67.86,1.34,1.27,2-.83-.66-3.47-.9-6.87.08S84.51,425.91,87.9,423Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.27,414.19c3.51-3,5.64,3,3.4,5.95-2.08,3-3.17,5.36-3.07,6.41-.36-.71-.74-1.41-1.13-2.11C97.66,424.43,95.09,417.2,98.27,414.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,420.66c.12,0-2.3-6.43-5-9.07s-5.17-1.39-5.56.18,1.45,3.36,3.29,4.51C89.44,417.27,94.82,420.55,94.78,420.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,420.91h0a.27.27,0,0,0,.26-.15v0a.18.18,0,0,0,0-.2c-.24-1.25-2.73-6.86-5-9.14a4.23,4.23,0,0,0-4.07-1.51A2.6,2.6,0,0,0,84,411.71c-.56,2.12,2.46,4.2,3.39,4.78,1.86,1,6.76,4,7.18,4.31A.33.33,0,0,0,94.72,420.91Zm-7.33-10.54a4.59,4.59,0,0,1,2.22,1.39c2.11,2.09,4,6.52,4.69,8.23-.45-.29-1.16-.73-2.28-1.41-1.44-.88-3.35-2-4.37-2.53-1.76-1.1-3.53-2.79-3.16-4.22A2.13,2.13,0,0,1,86,410.38,2.85,2.85,0,0,1,87.39,410.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.28,466.43a.46.46,0,0,0,.63-.06,58.87,58.87,0,0,0,11.68-56.22.47.47,0,0,0-.89.28,57.94,57.94,0,0,1-11.49,55.33.45.45,0,0,0,.05.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,446.74c5.34,1.9,3.74,10.92,3.5,10.93-.47.86-1,1.7-1.48,2.53.27-1.28-.93-4.26-3.86-7.36S106,444.75,111,446.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13,452.94c5.18,2.05,0,7.67-4.46,7-4.36-.56-7.53-.37-8.61.35.57-.8,1.12-1.61,1.66-2.43C114.85,458,121.16,451.17,126.13,452.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.48,438.72c5.58,1,5.55,10,5.33,10.09q-.48,1.37-1,2.7c0-1.28-1.65-4-5.08-6.54S108.19,437.59,113.48,438.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,442.27c5.44,1.16,1.26,7.52-3.21,7.54-4.38.17-7.46.87-8.39,1.74q.63-1.31,1.2-2.64C119.23,449.07,124.26,441.38,129.47,442.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,430.42c5.66,0,7.15,8.95,6.94,9-.15.94-.34,1.87-.54,2.81-.18-1.27-2.31-3.64-6.11-5.57S109.2,430.2,114.61,430.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,431.25c5.56.23,2.5,7.18-1.89,7.94s-7.21,2.08-8,3.09c.27-.92.51-1.85.74-2.78C122,439.63,125.68,431.24,131,431.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.33,422c5.59-.9,8.55,7.65,8.36,7.75,0,.95,0,1.91-.07,2.86-.39-1.22-2.88-3.19-7-4.46S109,422.72,114.33,422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.59,420.11c5.52-.69,3.67,6.69-.54,8.17s-6.75,3.26-7.35,4.37c.11-.94.2-1.9.27-2.85C123.16,429.91,125.39,421,130.59,420.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,413.75c5.36-1.83,9.74,6.18,9.56,6.31.16.94.3,1.89.41,2.84-.59-1.14-3.38-2.68-7.6-3.25S107.46,415.34,112.63,413.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.33,409.11c5.33-1.62,4.77,6,.86,8.21-3.75,2.27-6.1,4.36-6.5,5.57,0-1-.13-1.91-.22-2.87C122.68,420.1,123.36,410.87,128.33,409.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.34,414.54c.13.07.58-8.2-1.09-12.42-1.51-4.2-5-4.05-6.2-2.5s0,4.41,1.43,6.57C117.1,408.2,121.44,414.44,121.34,414.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.16,414.78l0,0a.34.34,0,0,0,.36,0l0,0a.24.24,0,0,0,.08-.23c.35-1.5.33-8.89-1.11-12.52-.75-2.06-2.11-3.4-3.75-3.65a3.16,3.16,0,0,0-3,1.08c-1.64,2.08.67,5.83,1.42,6.93,1.58,2,5.53,7.64,5.82,8.24A.28.28,0,0,0,121.16,414.78Zm-3-15.17a5.41,5.41,0,0,1,1.77,2.61c1.32,3.33,1.3,9.15,1.18,11.35-.36-.54-.93-1.37-1.83-2.67-1.17-1.66-2.72-3.83-3.59-4.91-1.41-2.06-2.53-4.79-1.43-6.18a2.57,2.57,0,0,1,2.41-.85A3.35,3.35,0,0,1,118.19,399.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.65,467.56a.28.28,0,0,1-.33-.18A35,35,0,0,1,670,433.87a.27.27,0,0,1,.41.35,34.51,34.51,0,0,0-6.52,33,.26.26,0,0,1-.17.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.74,456.15c-3.37-.2-4.58,5.11-4.46,5.18.07.57.14,1.15.23,1.73.15-.77,1.5-2.12,3.83-3.14S670,456.22,666.74,456.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657,456c-3.31-.08-1.75,4.22.84,4.85s4.21,1.54,4.64,2.18c-.13-.57-.25-1.14-.35-1.71C662,461.41,660.13,456.22,657,456Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.22,451.17c-3.28-.76-5.37,4.22-5.26,4.3,0,.57-.06,1.14-.07,1.71.28-.71,1.84-1.8,4.3-2.4S670.38,451.78,667.22,451.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.64,449.41c-3.25-.62-2.44,3.83,0,4.87s3.88,2.21,4.2,2.9c0-.57-.05-1.14-.05-1.72C661.68,455.51,660.7,450.13,657.64,449.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.53,446.36c-3.12-1.29-6,3.25-5.9,3.34-.13.55-.25,1.11-.36,1.66.4-.65,2.11-1.45,4.64-1.63S671.54,447.49,668.53,446.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.37,443c-3.1-1.16-3,3.35-.8,4.78s3.47,2.82,3.66,3.55c.06-.57.14-1.13.23-1.69C662.34,449.7,662.27,444.25,659.37,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.62,441.83c-2.85-1.79-6.46,2.21-6.38,2.31-.22.52-.43,1.05-.62,1.58.49-.57,2.32-1.08,4.84-.83S673.4,443.45,670.62,441.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.15,437c-2.86-1.66-3.56,2.81-1.59,4.6s2.94,3.35,3,4.1c.16-.55.33-1.09.52-1.63C664,444.1,664.8,438.7,662.15,437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.47,437.68c-2.52-2.24-6.76,1.13-6.7,1.24-.31.48-.6,1-.88,1.47.58-.49,2.47-.69,4.92,0S675.94,439.75,673.47,437.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.94,431.5c-2.54-2.12-4,2.21-2.37,4.3s2.33,3.81,2.27,4.56c.25-.51.51-1,.79-1.52C666.49,438.83,668.26,433.62,665.94,431.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.51,436.1c-.08,0,1.59-4.63,3.48-6.56s3.69-1.05,4,.07-1,2.43-2.31,3.27S668.49,436,668.51,436.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.56,436.27h0a.19.19,0,0,1-.19-.11h0a.14.14,0,0,1,0-.15,19.7,19.7,0,0,1,3.51-6.6,3,3,0,0,1,2.9-1.13,1.9,1.9,0,0,1,1.39,1.28c.42,1.52-1.72,3-2.39,3.47-1.32.72-4.8,2.91-5.09,3.17A.19.19,0,0,1,668.56,436.27Zm5.14-7.63a3.27,3.27,0,0,0-1.58,1,19.66,19.66,0,0,0-3.27,5.94l1.62-1c1-.65,2.38-1.47,3.11-1.86,1.24-.81,2.49-2,2.21-3.06a1.5,1.5,0,0,0-1.12-1A2,2,0,0,0,673.7,428.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.33,469.05a.33.33,0,0,1-.45,0,42.21,42.21,0,0,1-9-40.17.34.34,0,1,1,.64.2,41.52,41.52,0,0,0,8.84,39.53.33.33,0,0,1,0,.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.19,455c-3.81,1.42-2.56,7.86-2.39,7.87.35.61.71,1.21,1.09,1.8-.2-.91.62-3.06,2.69-5.32S660.77,453.48,657.19,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.39,459.57c-3.68,1.53.12,5.51,3.28,4.95s5.39-.35,6.18.15c-.42-.56-.83-1.14-1.22-1.72C654.53,463.08,649.94,458.26,646.39,459.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.31,449.25c-4,.76-3.87,7.26-3.71,7.29.23.65.49,1.29.76,1.93,0-.93,1.14-2.89,3.57-4.75S659.09,448.38,655.31,449.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.89,452c-3.89.89-.83,5.4,2.38,5.36s5.35.55,6,1.16c-.31-.62-.61-1.24-.89-1.87C651.3,456.73,647.61,451.27,643.89,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.41,443.31c-4.06.09-5,6.49-4.88,6.55q.18,1,.42,2c.12-.91,1.61-2.63,4.32-4.06S658.28,443.09,654.41,443.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.7,444.08c-4,.23-1.72,5.18,1.44,5.67s5.19,1.42,5.75,2.13c-.2-.65-.39-1.31-.56-2C649.21,450,646.48,444,642.7,444.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.52,437.3c-4-.59-6,5.57-5.91,5.65,0,.68,0,1.36.08,2,.27-.87,2-2.31,4.94-3.27S658.37,437.73,654.52,437.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.84,436.1c-4-.44-2.56,4.83.48,5.84s4.87,2.26,5.31,3.06c-.09-.68-.16-1.36-.22-2C648.27,443,646.58,436.68,642.84,436.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.65,431.34c-3.87-1.25-6.92,4.53-6.79,4.62-.1.68-.19,1.36-.26,2.05.41-.82,2.39-2,5.41-2.42S659.37,432.42,655.65,431.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.34,428.19c-3.84-1.11-3.35,4.38-.53,5.89s4.43,3.06,4.73,3.92c0-.69.06-1.37.12-2.06C648.51,436,647.92,429.4,644.34,428.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.41,432c-.09.05-.51-5.87.64-8.92s3.56-2.95,4.43-1.85.07,3.16-1,4.72S649.34,431.93,649.41,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.54,432.17l0,0a.23.23,0,0,1-.26,0s0,0,0,0a.14.14,0,0,1-.06-.16c-.27-1.07-.33-6.37.66-9a3.63,3.63,0,0,1,2.65-2.66,2.28,2.28,0,0,1,2.15.74c1.2,1.47-.42,4.19-.94,5-1.11,1.43-3.88,5.54-4.08,6A.2.2,0,0,1,649.54,432.17Zm2-10.91a4,4,0,0,0-1.24,1.9c-.9,2.4-.83,6.57-.72,8.15.25-.4.65-1,1.29-1.94.82-1.2,1.91-2.77,2.52-3.56,1-1.49,1.76-3.46.95-4.44a1.81,1.81,0,0,0-1.73-.58A2.39,2.39,0,0,0,651.5,421.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "382.68 230.35 377.95 230.04 377.47 243.44 382.68 243.12 382.68 230.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.47,243.94a.45.45,0,0,1-.34-.15.47.47,0,0,1-.16-.37l.48-13.4a.48.48,0,0,1,.16-.35.56.56,0,0,1,.37-.13l4.73.32a.49.49,0,0,1,.47.49v12.77a.5.5,0,0,1-.47.5l-5.21.32Zm1-13.37L378,242.9l4.19-.25V230.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.51 228.31 382.68 230.35 382.73 246.14 416.12 252.55 414.51 228.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.12,253.05H416l-33.4-6.42a.49.49,0,0,1-.4-.49l-.05-15.78a.48.48,0,0,1,.46-.5l31.84-2.05a.5.5,0,0,1,.53.46l1.61,24.25a.49.49,0,0,1-.17.41A.5.5,0,0,1,416.12,253.05Zm-32.89-7.32,32.35,6.21-1.53-23.1-30.87,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,230s-13.08-5.52-14.82-5.52-6.93,6.94-8.35,9.3-.47,3.78.79,5.2,5.83,3.31,9,3,13.08-1.42,13.08-1.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.83,242.55c-3.27,0-7.41-1.82-8.64-3.19s-2.44-3.13-.84-5.8c1-1.61,6.56-9.54,8.78-9.54,1.79,0,13.66,5,15,5.56a.52.52,0,0,1,.31.48l-.32,10.55a.51.51,0,0,1-.44.49c-.1,0-10,1.1-13.09,1.42C364.35,242.54,364.09,242.55,363.83,242.55Zm-.7-17.53c-1.28,0-6.22,6.23-7.92,9.06-1.26,2.09-.45,3.28.73,4.61s5.55,3.13,8.56,2.83c2.74-.27,10.7-1.15,12.65-1.37l.29-9.78C372.21,228.17,364.31,225,363.13,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,451.1s-3.17-.2-3.37.79.79,10.91,1.78,11.7,3,1.39,7.74,1.59a75.79,75.79,0,0,0,11.5-.8l-.79-11.3Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,465.7c-.46,0-.91,0-1.34,0-4.37-.18-6.77-.69-8-1.7s-2.14-11.32-2-12.19c.25-1.28,2.8-1.26,3.89-1.19h0l17.27,2,.85,12.18-.46.07A84.74,84.74,0,0,1,267.43,465.7Zm-8.13-14.12a3.85,3.85,0,0,0-2.22.41c-.21,1,.86,10.44,1.61,11.22,1,.83,3.41,1.3,7.44,1.47a72,72,0,0,0,10.95-.73l-.73-10.42-16.44-1.93C259.71,451.58,259.5,451.58,259.3,451.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.26,351.66s0,16.31-2.2,25.57,1.45,28.88,4.1,39.89a80.47,80.47,0,0,1,2.2,20.28s-4.85,6.61-4,9.7,1.63,4.31,5.15,5.19,4-.8,9,2.74c6.18,4.39,14.1,6.17,16.31,3.53s-.89-4-2.65-5.29-5.73-7.5-8.81-11.9S274,421.53,274,408.31s6.49-51.8,6.49-51.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.21,460.29c-3.74,0-9-2-13-4.85-3.23-2.29-4.42-2.31-5.93-2.34a11,11,0,0,1-2.86-.33c-3.83-.95-4.62-2.42-5.51-5.54s3.26-9,4-10a81.18,81.18,0,0,0-2.2-20c-1.14-4.77-6.72-29.11-4.1-40.13,2.17-9.09,2.19-25.28,2.19-25.45v-.61l25.32,5.07-.08.47c-.07.39-6.48,38.69-6.48,51.72,0,3.63-.13,7.44-.26,11.12-.33,9.56-.65,18.59,1.5,21.65.69,1,1.44,2.08,2.19,3.18,2.44,3.58,5.21,7.63,6.51,8.61.27.2.56.39.87.6,1.18.8,2.53,1.7,2.72,3a3.06,3.06,0,0,1-.86,2.38A5,5,0,0,1,283.21,460.29Zm-26.45-108c0,3.06-.26,16.88-2.21,25.07-2.57,10.8,3,34.94,4.09,39.67a82,82,0,0,1,2.22,20.41v.15l-.09.13c-1.3,1.78-4.55,6.92-3.89,9.26.84,2.91,1.43,4,4.8,4.84a10.1,10.1,0,0,0,2.63.3c1.61,0,3,.06,6.49,2.52,5.91,4.2,13.66,6,15.63,3.62a2.09,2.09,0,0,0,.64-1.59c-.13-.9-1.28-1.67-2.29-2.35-.32-.22-.63-.42-.91-.63-1.43-1.08-4.13-5-6.74-8.84l-2.18-3.18c-2.34-3.33-2-12.1-1.68-22.26.13-3.67.26-7.46.26-11.08,0-12.32,5.67-46.92,6.41-51.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.45,354.75s-5.29,22.48-3.52,32.61,2.77,38.14,2.33,49.6c-.22,5.73-2.65,9.3-3.39,11.65a8.48,8.48,0,0,0,1.85,8.52,6.09,6.09,0,0,0,4.31,2.1c4.85,0,5.61-.23,12.22,2.85s13.66,3.09,17.19,1.32,2.2-3.08-1.77-4.84-7.06-7.13-13.12-11.54c-3.35-2.43-3.35-12.47-3.35-12.47s8-56.44,9.73-67A92.49,92.49,0,0,0,297.25,349Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.22,465.09A26.89,26.89,0,0,1,287,462.54c-6.06-2.83-7-2.83-11.06-2.81h-1a6.54,6.54,0,0,1-4.67-2.25,9,9,0,0,1-2-9,23.46,23.46,0,0,1,.9-2.2,24.21,24.21,0,0,0,2.47-9.32c.43-11.12-.54-39.22-2.33-49.49-1.76-10.12,3.32-31.89,3.54-32.82l.07-.3,24.68-5.94,0,.6a94,94,0,0,1-1.32,18.62c-1.75,10.45-9.65,66.44-9.73,67,0,0,0,9.74,3.14,12a51.46,51.46,0,0,1,7.09,6.47c2.12,2.21,3.95,4.12,5.95,5,2.44,1.09,4.07,2.06,4.1,3.31s-1.31,1.94-2.32,2.44A14.87,14.87,0,0,1,298.22,465.09Zm-21.46-6.37c3.5,0,4.86.18,10.7,2.91,6.59,3.08,13.42,3,16.75,1.33,1.55-.78,1.78-1.29,1.77-1.53,0-.57-1.19-1.39-3.51-2.42s-4.07-2.94-6.27-5.23a51,51,0,0,0-6.94-6.35c-3.52-2.56-3.56-12.46-3.56-12.88.09-.64,8-56.64,9.74-67.1a96.64,96.64,0,0,0,1.34-17.8l-22.91,5.51c-.61,2.7-5.07,22.83-3.45,32.12,1.8,10.32,2.77,38.54,2.34,49.7a24.76,24.76,0,0,1-2.56,9.68c-.36.81-.67,1.51-.86,2.1a8,8,0,0,0,1.74,8,5.58,5.58,0,0,0,3.95,2h1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.49,453.48l.39,12.29s.4.6,7.94,1,6.74-.39,17.05,1.39S307,466,307.16,465.38a20.29,20.29,0,0,0-.2-3.77s-4,2.18-13.09,1-12.29-3.37-16.26-6A24.19,24.19,0,0,0,268.49,453.48Z",
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.8,469.12a29.54,29.54,0,0,1-5-.47c-7.05-1.22-8.82-1.23-11.76-1.25-1.34,0-2.87,0-5.24-.14-7.79-.41-8.19-1-8.32-1.21l-.08-.12-.42-13,.57.07a24.62,24.62,0,0,1,9.34,3.25l.29.19c3.74,2.43,7,4.54,15.77,5.68s12.74-.91,12.78-.93l.65-.35.09.73a17.48,17.48,0,0,1,.17,4S306.06,469.12,298.8,469.12Zm-29.43-3.67c.5.16,2.19.54,7.47.82,2.35.12,3.86.13,5.2.13,2.88,0,4.79,0,11.92,1.26,10.51,1.81,12.71-2.4,12.72-2.44a14.28,14.28,0,0,0-.14-2.88c-1.48.57-5.53,1.69-12.73.76-9-1.18-12.34-3.34-16.19-5.85l-.28-.18a23.39,23.39,0,0,0-8.33-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55,447l-3.22,13.4s4.17,2.18,7.54,2.18l3.37-8.33S294.15,448.9,289.55,447Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.21,463.1h-.34c-3.45,0-7.59-2.15-7.77-2.24l-.34-.18,3.44-14.34.54.22c4.7,1.92,7.81,7.24,7.94,7.46l.12.21Zm-7.3-3a19.6,19.6,0,0,0,6.63,1.94l3.15-7.77c-.59-.94-3.19-4.86-6.79-6.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.57,219.19a8,8,0,0,1,1-4.11c1.2-2.22.17-4.28-1.71-2.74s-2.74,4.8-2.74,4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,220.12l-4.58-2.75.1-.36c0-.14.92-3.43,2.9-5,1.27-1,2.11-.58,2.41-.34.82.68.85,2.24.06,3.7a7.66,7.66,0,0,0-1,3.83Zm-3.41-3.21,2.35,1.41a9.23,9.23,0,0,1,1.07-3.47c.63-1.18.51-2.18.18-2.45s-.65-.07-1.14.33A9.58,9.58,0,0,0,310.74,216.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.21,
    y: 190.27,
    width: 35.94,
    height: 65.38,
    transform: "translate(30.57 -35.19) rotate(7.27)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3,258.22l-36.64-4.68,8.4-65.84,36.64,4.67Zm-35.53-5.54,34.67,4.42,8.14-63.86-34.66-4.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,238.15a195.2,195.2,0,0,0-14.63,33.48c-5.82,18.13-4.19,84.61-4,85.31s4.42,3,13.25,3,15.11-.47,15.11-.47a27.55,27.55,0,0,0,12.09,2.79c6.28-.23,13.25-3,13.25-3s.93.93,5.35,0a36.4,36.4,0,0,0,8.36-3l4.19-2.33s-3.26-30.45-6-41.37-4.89-58.81-5.35-60.9.46,4.18-.47-2.1a55.14,55.14,0,0,0-2.91-11.2Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.93,362.79A28.06,28.06,0,0,1,266.45,360c-1,.07-7,.46-15,.46-8.39,0-13.32-2.16-13.72-3.37-.12-.35-2-67,3.95-85.62a196.91,196.91,0,0,1,14.68-33.56l.15-.26,38.86.19.12.31a56.08,56.08,0,0,1,2.95,11.32c.08.54.15,1,.2,1.37a1.61,1.61,0,0,1,.26.69c.13.6.36,4.22.78,11.1,1,15.72,2.58,42,4.56,49.78,2.77,10.84,6,41.14,6.06,41.45l0,.33-4.47,2.49a36.72,36.72,0,0,1-8.51,3.07c-3.45.73-4.93.36-5.5.07a46.25,46.25,0,0,1-13.18,3ZM266.66,359l.12.07a27.09,27.09,0,0,0,11.84,2.73c6.12-.23,13-3,13.08-3l.31-.13.23.24h0s1,.68,4.89-.14a36,36,0,0,0,8.24-3l3.89-2.16c-.37-3.33-3.41-30.82-6-41-2-7.86-3.62-34.22-4.59-50-.27-4.44-.5-8.16-.65-9.92a1.14,1.14,0,0,1-.11-.33h0l0-.23a.41.41,0,0,0,0-.11c-.1-.49-.21-1.27-.39-2.48a54.9,54.9,0,0,0-2.77-10.78l-37.59-.18a195.71,195.71,0,0,0-14.46,33.12c-5.69,17.77-4.27,82.84-3.94,85.05.33.49,4.41,2.63,12.76,2.63,8.71,0,15-.46,15.08-.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.57,304.65a39.54,39.54,0,0,1-1.83-3.63l.91-.41c.58,1.29,1.18,2.48,1.79,3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.68,298.51a118.89,118.89,0,0,1-5.54-20.29l1-.17a116.59,116.59,0,0,0,5.48,20.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.74,311.64c-3.69-6-6.27-10.67-6.29-10.72l.87-.48c0,.05,2.6,4.71,6.27,10.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.52,
    y: 328.11,
    width: 1,
    height: 20.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.52,
    y: 353.59,
    width: 1,
    height: 4.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.26,260l-1-.06c.08-1.38.24-3,.47-4.92l1,.12C274.49,257,274.34,258.67,274.26,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.13,252l-1-.14c1-6.89,2.37-14,2.38-14.08l1,.2C277.49,238.09,276.1,245.18,275.13,252Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.16,
    y: 244.05,
    width: 12.23,
    height: 1,
    transform: "translate(-37.24 441.16) rotate(-75.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.71,349.08l-1-.1c.69-6.62-.91-27.59-.93-27.8l1-.08C303.85,322,305.4,342.38,304.71,349.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.42,164.81S290.7,171,290.7,178s-3.09,9.42-2.57,10.45,5-2.4,5.14.17-1.37,8.23-5.48,9.09-9.43-1.55-13.2-11.83S278.19,164.81,280.42,164.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.29,198.37c-3.13,0-8.32-1.82-12.17-12.31-2.61-7.13-.07-14.62,2.89-18.87.61-.86,2.15-2.88,3.41-2.88h.13l.12.07c.43.26,10.53,6.4,10.53,13.63a18.36,18.36,0,0,1-2.12,8.94,6,6,0,0,0-.51,1.21,6.82,6.82,0,0,0,1.4-.41c1.17-.43,2.38-.88,3.18-.36a1.48,1.48,0,0,1,.62,1.21c.2,3-1.6,8.71-5.88,9.61A8,8,0,0,1,286.29,198.37Zm-6-33a6.5,6.5,0,0,0-2.47,2.43c-2.83,4.06-5.25,11.19-2.77,18,4.35,11.86,10.28,12,12.62,11.51,3.67-.77,5.26-6,5.09-8.56,0-.23-.07-.38-.17-.44-.37-.25-1.52.17-2.28.45-1.15.43-2.23.82-2.64,0-.29-.59,0-1.22.5-2.18a17.34,17.34,0,0,0,2-8.5C290.2,171.79,281.54,166.11,280.3,165.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.59,169.75s-10.3,1.12-15.18,14.62,7.5,42.73,8.44,44.79.93,9,.93,9l38.24.19s-1.13-22.86-2.81-32.42-5.06-21.55-10.69-28.3S272.72,167.5,262.59,169.75Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.54,238.84l-39.26-.19v-.5c0-1.89-.16-7.17-.89-8.78-.14-.31-13.56-31-8.45-45.17,4.79-13.26,14.91-14.86,15.57-14.95,10.26-2.27,13.53,1,19.4,8.05,6.35,7.62,9.49,21.15,10.79,28.53,1.67,9.48,2.81,32.26,2.82,32.49Zm-38.26-1.18,37.21.18c-.18-3.48-1.26-23.22-2.78-31.83-1.28-7.29-4.36-20.62-10.57-28.07-5.75-6.91-8.7-9.87-18.44-7.71h-.05c-.1,0-10.07,1.28-14.77,14.3-5,13.8,8.29,44.11,8.42,44.41C257.13,230.78,257.26,236,257.28,237.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.41,231.6a60.85,60.85,0,0,1,.37,6.55l38.24.19s-.17-3.37-.47-8.06H256.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.54,238.84l-39.26-.19v-.5a59,59,0,0,0-.37-6.49v-1.88H295l0,.47c.3,4.69.47,8.07.47,8.07Zm-38.26-1.18,37.21.18c-.05-1.07-.19-3.69-.41-7.06H256.91v.78A57.57,57.57,0,0,1,257.28,237.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,224.33s1.89-4.63,1.37-5.14-3.93-3.25-4.79-3.25-7.19.51-7.19,1.37,1.71,1.2,1.71,1.2-1.54,1-1.37,1.88S305.1,222,305.1,222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.49,225,305,222.48c-1-.24-3.3-.94-3.51-2a2.13,2.13,0,0,1,.83-1.79,1.66,1.66,0,0,1-1.18-1.39c0-1.64,7.61-1.87,7.69-1.87,1.18,0,4.94,3.19,5.15,3.4s.74.75-1.26,5.67Zm-10.36-7.53a2.55,2.55,0,0,0,1.27.6l1.18.23-1,.67c-.6.4-1.22,1.06-1.16,1.37a6.43,6.43,0,0,0,2.81,1.23l6.68,2.18a16.75,16.75,0,0,0,1.25-4.21c-.78-.74-3.78-3-4.38-3.05C307.61,216.44,303,216.91,302.13,217.42Zm11,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,221.64c-1.78-1.37-3.81-2.87-4.14-3a21.32,21.32,0,0,0-3.23,0l-.06-1a17.89,17.89,0,0,1,3.61,0,43.46,43.46,0,0,1,4.43,3.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45,193.63l27.74,42.71s4.26,2,7.09,3.31,11.19.63,18.91,0,38-5.35,38-5.35a30.34,30.34,0,0,0,3.78,4.57c1.89,1.73,5.36,3.94,6.46,4.09s4.1-.94,4.1-.94a5.63,5.63,0,0,0,3.15,1.1c1.42-.16,2.05-.47,2.21-1.1a30.87,30.87,0,0,0-1-6.94c-.47-1.42-4.25-5.2-4.25-5.2s-5.52-4.73-6.46-4.88-12.93.47-12.93.47L305.1,222s1.26-.63-1.26-1.89a14.69,14.69,0,0,0-5-1.42s-22.07-44.91-25.69-48.07-11-1.89-15.76,2.53a12.83,12.83,0,0,0-4.26,9.77",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,243.63a6.12,6.12,0,0,1-3-1.06,12.68,12.68,0,0,1-4.1.89c-1.29-.19-4.88-2.54-6.73-4.23a30,30,0,0,1-3.68-4.39c-3.23.5-30.5,4.72-37.73,5.31-8.82.72-16.34,1.21-19.16,0s-7.06-3.29-7.11-3.32a.55.55,0,0,1-.2-.17L258,193.91a.51.51,0,0,1,.15-.7.5.5,0,0,1,.69.15L286.53,236c.73.35,4.43,2.12,7,3.25,2.81,1.25,12,.5,18.66,0,7.62-.63,37.68-5.31,38-5.36a.51.51,0,0,1,.5.22,29,29,0,0,0,3.7,4.48c1.93,1.76,5.28,3.84,6.19,4a13,13,0,0,0,3.86-.92.5.5,0,0,1,.46.06,5,5,0,0,0,2.81,1c1.44-.16,1.71-.45,1.77-.72a33.36,33.36,0,0,0-.93-6.66c-.36-1.07-3.11-4-4.13-5-2.59-2.22-5.64-4.62-6.2-4.75s-8.2.24-12.81.48l-40.29-3.47a.5.5,0,0,1-.18-.94s0-.38-1.26-1a14.33,14.33,0,0,0-4.85-1.37.5.5,0,0,1-.42-.28c-7.62-15.5-22.76-45.47-25.57-47.91-3.36-2.92-10.55-1.72-15.09,2.51a12.48,12.48,0,0,0-4.1,9.36.49.49,0,0,1-.45.54.48.48,0,0,1-.54-.45A13.22,13.22,0,0,1,257,172.78c5-4.64,12.65-5.82,16.43-2.53,3.55,3.09,23.72,44,25.68,48a15.27,15.27,0,0,1,4.95,1.44c1.26.64,1.85,1.23,1.85,1.87v0l39.45,3.4c1.16-.07,12-.63,13-.47s5.38,3.87,6.7,5c.43.42,3.91,3.94,4.41,5.43a30.44,30.44,0,0,1,.95,7.21c-.26,1.07-1.42,1.34-2.63,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.91,242a30.87,30.87,0,0,0-1-6.94c-.47-1.42-4.25-5.2-4.25-5.2s-5.52-4.73-6.46-4.88-12.93.47-12.93.47l-31.74-2.86-2.94,17.17,1.55-.13c7.73-.63,38-5.35,38-5.35a30.34,30.34,0,0,0,3.78,4.57c1.89,1.73,5.36,3.94,6.46,4.09s4.1-.94,4.1-.94a5.63,5.63,0,0,0,3.15,1.1C369.12,243,369.75,242.65,369.91,242Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,243.63a6.12,6.12,0,0,1-3-1.06,12.68,12.68,0,0,1-4.1.89c-1.29-.19-4.88-2.54-6.73-4.23a30,30,0,0,1-3.68-4.39c-3.23.5-30.5,4.72-37.73,5.31l-1.56.13a.52.52,0,0,1-.41-.16.51.51,0,0,1-.12-.43l2.94-17.17a.49.49,0,0,1,.53-.41L345.37,225c1.16-.07,12-.63,13-.47s5.38,3.87,6.7,5c.43.42,3.91,3.94,4.41,5.43a30.44,30.44,0,0,1,.95,7.21h0c-.26,1.07-1.42,1.34-2.63,1.48Zm-2.91-2.11a.5.5,0,0,1,.29.09,5,5,0,0,0,2.81,1c1.44-.16,1.71-.45,1.77-.72a33.26,33.26,0,0,0-.93-6.66c-.36-1.07-3.11-4-4.13-5-2.59-2.22-5.64-4.62-6.2-4.75s-8.2.24-12.81.48L314,223.15l-2.75,16.08.91-.07c7.62-.63,37.68-5.31,38-5.36a.51.51,0,0,1,.5.22,29,29,0,0,0,3.7,4.48c1.93,1.76,5.28,3.84,6.19,4a13,13,0,0,0,3.86-.92A.47.47,0,0,1,364.55,241.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,231.8a.48.48,0,0,1-.2,0,.49.49,0,0,1-.26-.65c1.61-3.89,9.32-8.7,9.65-8.9a.49.49,0,0,1,.69.16.51.51,0,0,1-.16.69c-.08.05-7.77,4.84-9.26,8.43A.49.49,0,0,1,292.34,231.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,227.55a.52.52,0,0,1-.33-.12.51.51,0,0,1-.05-.71c2-2.28,10.71-5.37,11.09-5.5a.48.48,0,0,1,.63.3.5.5,0,0,1-.3.64c-2.47.86-9.18,3.49-10.66,5.21A.49.49,0,0,1,288.4,227.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.16 161.21 278.36 171.67 271.5 159.33 273.56 156.93 283.16 161.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.4,172.77l-7.5-13.5,2.52-3,10.4,4.64Zm-6.29-13.38,6.21,11.17,4.17-9.1-8.79-3.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,123.51s3.08,5.31,3.6,8.91a42.47,42.47,0,0,1,.17,7.89s4.45,6,4.45,7.54-3.59,3.08-3.59,3.08-1,7.71-1.2,9.43-1.72,3.6-3.43,3.6-12.51-3.43-14.05-4-6.35-13.36-2.75-22.45S288.13,123.51,288.13,123.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.13,164.46c-2,0-14.09-3.93-14.21-4s-.74-.25-1.67-2.24c-2-4.33-4.17-13.82-1.38-20.87C274.51,128.2,287.4,123.25,288,123l.4-.15.21.37c.13.22,3.14,5.44,3.66,9.09a41.8,41.8,0,0,1,.19,7.81c1,1.3,4.44,6.13,4.44,7.69s-2.64,3-3.64,3.42c-.18,1.4-1,7.63-1.16,9.14C291.86,162.32,290.14,164.46,288.13,164.46Zm-.22-40.32c-2.21.91-13,5.71-16.11,13.61-3.48,8.78,1.16,21.17,2.44,21.79,2,.66,12.33,3.92,13.89,3.92s2.79-1.73,2.93-3.15c.17-1.71,1.16-9.13,1.2-9.44l0-.29.26-.11c1.37-.59,3.29-1.79,3.29-2.62s-2.54-4.81-4.35-7.25l-.11-.15v-.18a42.36,42.36,0,0,0-.17-7.78C290.82,129.57,288.61,125.4,287.91,124.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3,140c0,1-.46,1.89-1,1.89s-1-.85-1-1.89.46-1.88,1-1.88S288.3,138.92,288.3,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.34,136.74c-1.44-1.3-3.7-.12-3.72-.11l-.47-.88c.12-.06,2.9-1.51,4.86.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,153.85a4.79,4.79,0,0,1-3.93-2.47l.83-.55c1.5,2.24,3.21,2,3.28,2l.16,1A1.28,1.28,0,0,1,289.93,153.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.76,118s-3.95,5.31-10.29,15.76-6.85,27.77-6.85,27.77,5.31,6.85,6.68,13-1.71,8.91-1.71,8.91-2.79-9.45-7.48-12.87-9.49-3.65-10.52-.87,4.29,8.94,1.89,14.09-11.66,9.93-11,15.59,5,10.11,3.6,17-8.57,9.59-12.17,7.19-2.23-4.45-1.88-5a3.51,3.51,0,0,0-.52-5c-2.4-2.39-9.42-7.54-7.71-12.16s8.23-5.83,6.17-11.66-10.28-14.05-6.85-20.56,10.62-7.2,8.91-15.6-3.26-9.25-1.37-17.31,10.79-18.33,14.73-21.25,15.6-5.48,18.34-5.31,9.43,2.91,11.65,3.6S294,114.94,292.76,118Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,225a6,6,0,0,1-3.35-.94c-2.58-1.73-3.3-3.74-2-5.66a3,3,0,0,0-.45-4.34c-.39-.39-.89-.84-1.46-1.36-3.16-2.85-7.92-7.15-6.37-11.34a12,12,0,0,1,3.48-4.47c2.06-1.91,3.84-3.57,2.69-6.84a35.78,35.78,0,0,0-3.09-5.85c-2.93-4.86-6.24-10.36-3.74-15.11a20.56,20.56,0,0,1,4.81-5.66c2.84-2.56,5.08-4.59,4.06-9.61-.43-2.09-.84-3.69-1.2-5.1-1.07-4.17-1.61-6.26-.17-12.42,1.92-8.22,10.87-18.54,14.93-21.54s15.89-5.58,18.66-5.41c2,.13,6.11,1.6,9.08,2.68,1.12.41,2.08.76,2.69.94.31.1.68.2,1.08.3,2,.53,4.7,1.26,5.54,2.9a2.49,2.49,0,0,1,0,2.09l-.06.12s-4,5.41-10.26,15.72c-5.86,9.66-6.7,25.5-6.78,27.35.8,1,5.38,7.29,6.67,13.07,1.42,6.39-1.74,9.28-1.87,9.4l-.59.52-.22-.76c0-.09-2.8-9.33-7.29-12.6-2.94-2.14-6.14-3.12-8.17-2.51a2.28,2.28,0,0,0-1.59,1.4c-.35,1,.28,2.66,1,4.46,1.08,2.87,2.42,6.44.91,9.67-1,2.14-3.13,4.21-5.19,6.22-3,2.93-6.11,5.95-5.73,9.1a24.38,24.38,0,0,0,1.81,6c1.3,3.3,2.66,6.71,1.78,11.09a10.57,10.57,0,0,1-6.25,7.76A8.74,8.74,0,0,1,248,225Zm26.45-114.66c-3,0-14,2.44-17.74,5.23-4.11,3-12.76,13.3-14.55,21-1.38,5.91-.9,7.8.17,11.94.36,1.42.77,3,1.21,5.15,1.13,5.58-1.54,8-4.37,10.56a19.2,19.2,0,0,0-4.59,5.37c-2.24,4.26.92,9.5,3.71,14.13a37,37,0,0,1,3.17,6c1.37,3.89-.82,5.93-2.95,7.9a11.23,11.23,0,0,0-3.22,4.09c-1.32,3.56,3.32,7.75,6.1,10.25.58.53,1.1,1,1.5,1.39a4,4,0,0,1,.61,5.54c-.39.6-1.47,2.22,1.71,4.34a6.28,6.28,0,0,0,5.75.15,9.56,9.56,0,0,0,5.65-7c.82-4.1-.48-7.37-1.73-10.54a25.42,25.42,0,0,1-1.88-6.27c-.44-3.64,2.85-6.84,6-9.93,2-1.95,4.06-4,5-5.94,1.32-2.84.12-6.06-.95-8.89-.77-2.06-1.44-3.85-.95-5.16a3.27,3.27,0,0,1,2.23-2c2.35-.7,5.82.31,9,2.66,4,2.89,6.57,9.81,7.39,12.26.76-1.08,2-3.58,1-7.79-1.33-6-6.53-12.76-6.59-12.83l-.11-.14v-.18c0-.17.59-17.56,6.93-28,5.93-9.78,9.82-15.14,10.26-15.74a1.43,1.43,0,0,0,0-1.22c-.63-1.24-3.19-1.93-4.89-2.38-.42-.11-.8-.21-1.12-.31-.63-.2-1.61-.55-2.74-1-2.91-1.06-6.89-2.5-8.8-2.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.9,231.74s-3.6,4.16-3,5.13a5.8,5.8,0,0,0,2.5,1.67s2.08-3.33,2.36-5.27S352.15,231.19,350.9,231.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,239a.51.51,0,0,1-.17,0,6,6,0,0,1-2.76-1.89c-.64-1.11,1.67-4.05,3.11-5.7a.37.37,0,0,1,.17-.13,2,2,0,0,1,2-.09c.48.36.64,1.06.48,2.14-.29,2-2.34,5.32-2.43,5.46A.49.49,0,0,1,350.35,239Zm.86-6.88c-1.67,1.93-3,4-2.91,4.49a4.51,4.51,0,0,0,1.84,1.27,17.27,17.27,0,0,0,2.07-4.72c.14-1-.07-1.18-.09-1.2S351.91,231.86,351.21,232.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.78,233.82s-4.43,3.61-4.43,4.72.69,2.08,1.53,1.66,3.6-2.91,3.88-4.71S355.74,233.82,354.78,233.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,240.8a1.34,1.34,0,0,1-.68-.2,2.42,2.42,0,0,1-.95-2.06c0-1.22,3.23-4,4.61-5.11a.54.54,0,0,1,.32-.11H355a1.35,1.35,0,0,1,1.14.33c.31.36.29.93.14,1.91-.32,2.07-3.27,4.65-4.15,5.09A1.38,1.38,0,0,1,351.48,240.8Zm3.48-6.48c-2,1.62-4.06,3.67-4.11,4.22a1.48,1.48,0,0,0,.48,1.21.27.27,0,0,0,.32,0c.75-.37,3.37-2.76,3.61-4.34a3,3,0,0,0,.08-1.13s-.2,0-.36,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.78,236.64s-3.22,3-3.06,3.77a2.11,2.11,0,0,0,1.88,1.34c.63,0,2.76-2.12,3.31-3.7S357.59,235.38,355.78,236.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.6,242.25a2.6,2.6,0,0,1-2.37-1.74c-.18-.88,1.65-2.79,3.21-4.24l.06,0c1.36-.95,2.15-.64,2.5-.37a2,2,0,0,1,.38,2.36C357.81,239.84,355.55,242.25,354.6,242.25Zm1.5-5.22c-1.36,1.26-2.84,2.89-2.89,3.33.1.45.94.89,1.39.89a7.85,7.85,0,0,0,2.84-3.36c.23-.65.14-1.1,0-1.23S356.79,236.55,356.1,237Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.75,238.68s-2.28,3.62-2,4,1.41,1.49,2,.7,2.36-2.91,2.21-4.32S358.62,237.74,357.75,238.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.16,244.18h0a2.77,2.77,0,0,1-1.84-1.23c-.15-.24-.4-.65,2.05-4.53a.35.35,0,0,1,.05-.08,2,2,0,0,1,2-.79,1.55,1.55,0,0,1,1,1.47c.16,1.4-1.18,3.18-2,4.24-.13.17-.24.31-.32.43A1.09,1.09,0,0,1,357.16,244.18Zm-1-1.64a1.85,1.85,0,0,0,.94.64c.05,0,.07,0,.11-.06l.34-.46c.61-.82,1.89-2.52,1.78-3.53,0-.34-.15-.58-.29-.63s-.56.09-.94.49A23.38,23.38,0,0,0,356.21,242.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.76,170s-8.26,7-9.06,9.26a16.33,16.33,0,0,0-.81,4.84S414,196.6,413.22,202.44s2.21,16.1,2.21,16.1L439.79,171Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.43,219h-.05a.5.5,0,0,1-.43-.36c-.12-.42-3-10.44-2.23-16.31.78-5.65,10.42-17,11.68-18.44a16.26,16.26,0,0,1,.83-4.82c.83-2.27,8.35-8.74,9.2-9.47a.52.52,0,0,1,.43-.11l5,1a.51.51,0,0,1,.35.72l-24.36,47.51A.5.5,0,0,1,415.43,219Zm19.47-48.48c-2.39,2.06-8.12,7.22-8.73,8.89a15.89,15.89,0,0,0-.78,4.67.47.47,0,0,1-.12.32c-.11.13-10.78,12.44-11.56,18.06-.62,4.49,1.11,11.78,1.86,14.67L439,171.39Zm-10,13.56h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.22,460.93l-.08,5s-8.5,1.49-15.3.85l-.21-3.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.51,467.46c-1.26,0-2.51,0-3.72-.16a.5.5,0,0,1-.45-.47l-.21-3.61a.49.49,0,0,1,.42-.52l15.6-2.27a.48.48,0,0,1,.4.12.52.52,0,0,1,.17.38l-.08,5a.5.5,0,0,1-.42.48A76.7,76.7,0,0,1,481.51,467.46Zm-3.2-1.12a68.89,68.89,0,0,0,14.33-.81l.07-4-14.56,2.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.56,440s-.73,4.95-1.84,6.63a14.15,14.15,0,0,1-7.37,5.93c-4.75,2-16.8,6.05-16.25,8.29s1.68,3.35,2.79,3.62a105.5,105.5,0,0,0,17.22,1.7c7.25,0,16.34.35,19.13-.77s5.58-2.23,8.65-2.23,9.21-.56,10.33-2.23-.56-9.49-1.4-11.73-2-5.67-2-5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.71,466.71l-4.35,0-4.25,0A106.6,106.6,0,0,1,437.77,465c-1.46-.37-2.61-1.82-3.15-4-.48-1.92,3.91-4,13.31-7.6,1.24-.48,2.36-.91,3.23-1.27,4.56-1.88,6-4.09,7.11-5.71s1.79-6.41,1.79-6.46a.51.51,0,0,1,.56-.42L489.91,443a.51.51,0,0,1,.41.34s1.15,3.46,2,5.66c.73,1.94,2.66,10.2,1.34,12.17s-8.21,2.46-10.74,2.46c-3,0-5.77,1.12-8.47,2.2C472.62,466.58,468.4,466.71,463.71,466.71ZM461,440.55c-.22,1.31-.88,4.9-1.85,6.34-1.17,1.77-2.74,4.13-7.59,6.12-.88.37-2,.8-3.25,1.28-3.57,1.38-13.05,5-12.7,6.42.45,1.81,1.33,3,2.43,3.27a104.53,104.53,0,0,0,17.09,1.69l4.26,0c6.15.05,12.51.11,14.68-.76,2.79-1.12,5.67-2.27,8.84-2.27,3.59,0,9-.7,9.91-2s-.54-8.86-1.45-11.27c-.68-1.83-1.58-4.5-1.88-5.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.53,300.18s1,61.45,1.3,67S480,402,485.18,416.25s5.6,29.81,5.6,29.81-10.15,2.06-12.43,2.38S467,446.49,467,446.49s-6.82-54.95-6.82-87.78,2.27-56.9,2.27-56.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.83,449c-3,0-10.63-1.91-11-2a.49.49,0,0,1-.37-.43c-.07-.55-6.83-55.35-6.83-87.84s2.25-56.71,2.27-56.95a.51.51,0,0,1,.41-.44l9.11-1.63a.49.49,0,0,1,.4.11.5.5,0,0,1,.19.37c0,.62,1,61.51,1.29,67,.31,5.21,7.08,34.51,12.33,48.95,5.17,14.22,5.62,29.81,5.63,30a.51.51,0,0,1-.4.51c-.42.08-10.19,2.06-12.46,2.39A4.91,4.91,0,0,1,477.83,449Zm-10.4-2.88c2.73.67,9.14,2.1,10.85,1.86,2-.28,10.05-1.91,12-2.3-.11-2.57-.91-16.46-5.55-29.22-5.4-14.85-12.07-43.84-12.38-49.24C472,362,471.14,307.1,471,300.78l-8.15,1.45c-.29,3.2-2.24,26.25-2.24,56.48C460.65,389.8,466.85,441.39,467.43,446.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.49,464.54l-.08,5s-8.49,1.49-15.29.85l-.22-3.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.79,471.07c-1.26,0-2.52-.05-3.72-.16a.49.49,0,0,1-.45-.47l-.21-3.61a.49.49,0,0,1,.42-.52L477.42,464a.52.52,0,0,1,.4.12.49.49,0,0,1,.17.39l-.07,5a.51.51,0,0,1-.42.49A79.1,79.1,0,0,1,465.79,471.07Zm-3.2-1.12a68.24,68.24,0,0,0,14.33-.81l.07-4-14.56,2.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.84,443.6s-.73,4.95-1.85,6.63-2.62,4-7.37,5.93-16.8,6.06-16.24,8.29,1.68,3.35,2.79,3.63a105.33,105.33,0,0,0,17.21,1.7c7.26,0,16.34.34,19.13-.78s5.59-2.23,8.66-2.23,9.21-.56,10.32-2.23-.55-9.49-1.39-11.73-2-5.67-2-5.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,470.33l-4.35,0-4.26,0a105.24,105.24,0,0,1-17.33-1.72c-1.46-.36-2.61-1.82-3.15-4-.48-1.91,3.91-4,13.31-7.6,1.24-.48,2.35-.91,3.22-1.27,4.57-1.88,6-4.09,7.12-5.71s1.78-6.41,1.79-6.46a.5.5,0,0,1,.56-.42l29.29,3.54a.48.48,0,0,1,.41.34s1.14,3.45,2,5.65c.73,1.94,2.65,10.21,1.34,12.18s-8.21,2.45-10.74,2.45c-3,0-5.65,1.07-8.47,2.2C456.89,470.19,452.67,470.33,448,470.33Zm-2.73-26.17c-.22,1.31-.88,4.9-1.85,6.35-1.17,1.76-2.75,4.12-7.6,6.12-.87.36-2,.79-3.24,1.27-3.57,1.38-13.05,5-12.7,6.43.45,1.8,1.33,3,2.42,3.26a104.53,104.53,0,0,0,17.09,1.69l4.27,0c6.15.05,12.51.11,14.68-.76,2.79-1.12,5.67-2.27,8.84-2.27,3.59,0,9-.7,9.91-2s-.55-8.86-1.45-11.27c-.69-1.83-1.58-4.5-1.88-5.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36,298.88s4.55,43.24,6.82,53.32,9.11,42.27,9.11,42.27,4.22,32.84,4.22,34.14v5.2s-3.46,3.62-3.46,5.25,1.58,9,1.58,9a97.25,97.25,0,0,0,14.25,2.78,108.11,108.11,0,0,0,17.58.28,335.83,335.83,0,0,0-2-39c-2.28-18.86-8.12-48.55-8.12-58s1.62-28.93,1.95-30.23,1.3-21.79,1.3-21.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.87,451.89a87.48,87.48,0,0,1-10.05-.52,98.63,98.63,0,0,1-14.33-2.79.49.49,0,0,1-.35-.37c-.06-.31-1.59-7.5-1.59-9.15s2.74-4.68,3.46-5.45v-5c0-1-3-24.95-4.22-34.08-.06-.28-6.84-32.26-9.09-42.22s-6.8-52.94-6.84-53.38a.48.48,0,0,1,.14-.4.51.51,0,0,1,.39-.15l43.25,3.25a.51.51,0,0,1,.46.53c-.1,2.1-1,20.57-1.32,21.88s-1.93,20.66-1.93,30.11c0,5.49,2,17.94,4.12,31.12,1.5,9.33,3,19,4,26.8a338.81,338.81,0,0,1,2,39.1.49.49,0,0,1-.46.49C475.45,451.66,472.17,451.89,467.87,451.89Zm-23.81-4.18a101.41,101.41,0,0,0,13.88,2.67,107.28,107.28,0,0,0,17,.31,338.74,338.74,0,0,0-2-38.5c-.94-7.8-2.49-17.44-4-26.77-2.12-13.21-4.13-25.7-4.13-31.27,0-9.5,1.63-29,2-30.35.23-.9.87-13,1.27-21.2l-42.16-3.17c.56,5.24,4.65,43.37,6.75,52.66,2.25,10,9,42,9.11,42.28.18,1.38,4.23,32.92,4.23,34.24v5.2a.56.56,0,0,1-.13.35c-1.29,1.34-3.33,3.86-3.33,4.9A83.63,83.63,0,0,0,444.06,447.71Zm1.45-13.9h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18,110.94s-5.7,10.44-5.7,12.74,1,3.62.65,4.28-5.42,7.73-5.75,9.54,3.29,4.11,3.78,4.6,1,9.21,1.65,11.68,2.79,4.44,4.6,4.44a18.11,18.11,0,0,0,4.11-.66l9.05,6.09L463.4,149l-.33-5.26s7.66-12.8,8.15-15.26.84-13.51-1.63-17.62-13.81-9.29-19.9-11.1-17.43,3-19.89,4.59-5.59,3.62-5.1,4.77A4.54,4.54,0,0,0,426.18,110.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.57,164.15a.47.47,0,0,1-.28-.09l-8.86-6a17.57,17.57,0,0,1-4,.62c-2.1,0-4.38-2.16-5.09-4.81a58.34,58.34,0,0,1-.88-6.46,37.48,37.48,0,0,0-.68-5l-.48-.36c-1.3-1-3.71-2.87-3.39-4.63.24-1.33,2.47-4.72,4.75-8.08.5-.75,1-1.45,1.05-1.59a2.71,2.71,0,0,0-.2-1,10.13,10.13,0,0,1-.51-3c0-2.18,4.44-10.53,5.56-12.61a5.06,5.06,0,0,1-1.3-1.74c-.63-1.46,2-3.21,4.8-5.07l.48-.32c2.27-1.51,14-6.54,20.31-4.65,5.51,1.64,17.48,6.81,20.19,11.32,2.52,4.2,2.24,15.24,1.69,18-.48,2.42-7.27,13.84-8.13,15.29l.32,5.11a.51.51,0,0,1-.25.46l-24.83,14.64A.59.59,0,0,1,438.57,164.15Zm-9.05-7.09a.47.47,0,0,1,.28.09l8.78,5.9,24.3-14.32-.31-4.95a.5.5,0,0,1,.07-.29c2.12-3.54,7.7-13.15,8.09-15.1.48-2.35.83-13.27-1.56-17.27-2.29-3.8-13-8.89-19.62-10.87-6.06-1.8-17.28,3.06-19.48,4.53l-.47.32c-1.54,1-4.74,3.14-4.44,3.83a4,4,0,0,0,1.3,1.59.52.52,0,0,1,.16.66c-1.57,2.87-5.64,10.72-5.64,12.5a9.12,9.12,0,0,0,.47,2.75,2.43,2.43,0,0,1,.13,1.75c-.1.2-.43.69-1.12,1.71-1.41,2.1-4.37,6.47-4.59,7.7s2.06,2.91,3,3.65a7.67,7.67,0,0,1,.62.51c.34.33.49,1.43.93,5.59a58.49,58.49,0,0,0,.85,6.31c.58,2.17,2.5,4.07,4.12,4.07a17.4,17.4,0,0,0,4-.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.59,110.87c-2.46-4.11-13.81-9.29-19.9-11.1s-17.43,3-19.89,4.59-5.59,3.62-5.1,4.77a4.54,4.54,0,0,0,1.48,1.81,3.26,3.26,0,0,0,2.63-.66c1.15-1,.82-2.14,7.89-3.45s8.77,3.2,6.31,5.67-7.07,5.59-6.25,8.22,8.22,5.92,8.22,5.92-.66,3,0,3.62a3.64,3.64,0,0,0,1.81.82s4.93-5.59,7.23-4.44,5.27,6.58,4.94,9.21-4.28,7.4-4.28,7.4l-2.79.66a11.16,11.16,0,0,0,11.18-.16s7.66-12.8,8.15-15.26S472.06,115,469.59,110.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.29,145.84a11.15,11.15,0,0,1-5.67-1.51.51.51,0,0,1-.23-.5.53.53,0,0,1,.38-.41l2.63-.61c.62-.77,3.78-4.79,4.06-7s-2.54-7.64-4.66-8.7c-1.42-.71-4.83,2.27-6.64,4.33a.52.52,0,0,1-.44.16,4.22,4.22,0,0,1-2.09-1c-.68-.68-.44-2.58-.22-3.69-1.64-.75-7.35-3.55-8.13-6.06-.74-2.35,2.05-4.82,4.51-7,.68-.6,1.32-1.17,1.86-1.71a2.7,2.7,0,0,0,.64-3.2c-.85-1.62-3.28-2.23-6.49-1.63-5.61,1-6.39,1.94-7.07,2.73a6.73,6.73,0,0,1-.59.61,3.8,3.8,0,0,1-3.07.77.53.53,0,0,1-.17-.08,5.11,5.11,0,0,1-1.66-2c-.63-1.46,2-3.21,4.8-5.07l.48-.32c2.27-1.51,14-6.54,20.31-4.65,5.51,1.64,17.48,6.81,20.19,11.32,2.52,4.2,2.24,15.24,1.69,18-.5,2.53-7.9,14.9-8.21,15.42a.52.52,0,0,1-.18.18A12.09,12.09,0,0,1,457.29,145.84Zm-3.94-1.76a10.73,10.73,0,0,0,9.36-.7c2.17-3.63,7.64-13.06,8-15,.48-2.35.83-13.27-1.56-17.27-2.29-3.8-13-8.89-19.62-10.87-6.06-1.8-17.28,3.06-19.48,4.53l-.47.32c-1.54,1-4.74,3.14-4.44,3.83a4,4,0,0,0,1.22,1.53,2.7,2.7,0,0,0,2.1-.56,3.83,3.83,0,0,0,.49-.5c.79-.92,1.69-2,7.64-3.06,3.67-.69,6.5.11,7.57,2.14a3.7,3.7,0,0,1-.82,4.37c-.56.57-1.21,1.15-1.91,1.76-2.23,2-4.76,4.23-4.22,6,.62,2,5.95,4.73,7.95,5.62a.49.49,0,0,1,.29.56c-.31,1.41-.38,2.92-.14,3.16a2.93,2.93,0,0,0,1.28.63c1.05-1.16,5.26-5.53,7.64-4.34,2.54,1.27,5.56,6.9,5.2,9.72s-4.22,7.45-4.38,7.65a.46.46,0,0,1-.27.17Zm9.72-.33h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.4,129.6c0,1.09-.41,2-.91,2s-.9-.89-.9-2,.4-2,.9-2S426.4,128.51,426.4,129.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.78,125.83a.52.52,0,0,1-.42-.22.51.51,0,0,1,.14-.7c1.31-.87,4.34-2,6.39.07a.5.5,0,0,1,0,.7.5.5,0,0,1-.71,0c-2-2-5.09,0-5.12.06A.51.51,0,0,1,422.78,125.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.35,143.94c-.36,0-.59,0-.62,0a.5.5,0,0,1-.45-.55.5.5,0,0,1,.55-.45,8.34,8.34,0,0,0,5.39-1.54.52.52,0,0,1,.71.08.5.5,0,0,1-.08.7A9,9,0,0,1,423.35,143.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.55,136c-2.42,0-4-3.1-4.07-3.23a.5.5,0,0,1,.23-.67.49.49,0,0,1,.67.22s1.37,2.68,3.17,2.68a.51.51,0,0,1,.5.5A.5.5,0,0,1,427.55,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.52 157.56 435.11 154.76 434.78 160.69 429.52 157.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.78,161.19a.59.59,0,0,1-.25-.07L429.27,158a.5.5,0,0,1-.25-.45.51.51,0,0,1,.28-.43l5.59-2.79a.5.5,0,0,1,.5,0,.48.48,0,0,1,.22.44l-.33,5.92a.52.52,0,0,1-.26.42A.48.48,0,0,1,434.78,161.19Zm-4.22-3.59,3.77,2.23.24-4.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.4 147.04 435.28 164.96 433.63 176.47 467.18 151.31 463.4 147.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.63,177a.47.47,0,0,1-.25-.07.48.48,0,0,1-.24-.5l1.64-11.51a.52.52,0,0,1,.23-.35l28.12-17.93a.49.49,0,0,1,.64.1l3.78,4.27a.49.49,0,0,1,.13.38.52.52,0,0,1-.2.35l-33.55,25.16A.47.47,0,0,1,433.63,177Zm2.11-11.71-1.44,10.09,32.15-24.11-3.14-3.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.18,151.31s-31.74,19.41-37.17,29.6S413.9,204.59,413.57,213s0,74.66-.16,79.6,16.11,15,33.54,16.61,34.54-6.09,36.18-7.08a48.14,48.14,0,0,0,4.94-3.94s-4.94-30.1-4.94-34-1.31-12.83-1.31-12.83l3.62-29.44S484,184.37,482,175.65s-10.85-23.84-10.85-23.84A3.2,3.2,0,0,0,467.18,151.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.89,309.91c-1.65,0-3.32-.07-5-.23-17.77-1.67-34.18-11.9-34-17.12.06-2,0-14.66,0-29.27,0-20.23-.06-45.41.13-50.33.23-5.93,5.43-14.19,10.45-22.18,2.26-3.58,4.39-7,6.05-10.1,5.43-10.2,36.05-29,37.35-29.79h0a3.67,3.67,0,0,1,4.57.59l.06.08c.36.62,8.94,15.3,10.91,24s3.4,44.77,3.46,46.3l-3.61,29.45a126.84,126.84,0,0,1,1.31,12.84c0,3.86,4.88,33.66,4.93,34a.49.49,0,0,1-.16.45,49.24,49.24,0,0,1-5,4C481.58,303.63,467.36,309.91,451.89,309.91Zm15.55-158.17c-.59.36-31.71,19.49-37,29.41-1.69,3.16-3.83,6.56-6.09,10.16-5,7.88-10.08,16-10.3,21.69-.19,4.9-.16,30.07-.13,50.29,0,14.62,0,27.25,0,29.3-.14,4.26,15.09,14.4,33.1,16.1,17,1.6,33.91-5.83,35.88-7a47.44,47.44,0,0,0,4.65-3.71c-.52-3.21-4.9-30.07-4.9-33.85s-1.29-12.67-1.31-12.76v-.13l3.62-29.44c0-.29-1.51-37.47-3.45-46-1.87-8.29-10.2-22.68-10.76-23.65A2.67,2.67,0,0,0,467.44,151.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,210.76a.46.46,0,0,1-.2,0,.51.51,0,0,1-.29-.57c.15-.61.35-1.27.58-1.94a.49.49,0,0,1,.63-.31.45.45,0,0,1,.19.11l1-1.55.07-.08c.14-.13,14.16-13.84,17.87-18.69,3.55-4.63,10.39-10.28,11.47-11.16l1.11-4.6a.48.48,0,0,1,.4-.38.5.5,0,0,1,.51.23l1.28,2c1.62-1.88,7.23-8.22,11.51-10.93,4.89-3.09,11.15-6.55,11.21-6.59a.5.5,0,0,1,.68.2.51.51,0,0,1-.2.68c-.06,0-6.29,3.48-11.15,6.56S449.05,174.9,449,175a.48.48,0,0,1-.42.17.52.52,0,0,1-.39-.23l-1-1.62-.87,3.61a.55.55,0,0,1-.17.27c-.08.06-7.73,6.27-11.43,11.1s-17,17.82-17.94,18.76l-2.33,3.49A.52.52,0,0,1,414,210.76Z",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.39,
    y: 235.4,
    width: 63.97,
    height: 46.72,
    transform: "translate(114.41 -135.35) rotate(19.88)",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.51,292.1a.47.47,0,0,1-.17,0l-60.16-21.75a.51.51,0,0,1-.28-.26.5.5,0,0,1,0-.38l15.89-43.94a.51.51,0,0,1,.26-.28.5.5,0,0,1,.38,0l60.16,21.76a.49.49,0,0,1,.28.25.58.58,0,0,1,0,.39L466,291.77A.5.5,0,0,1,465.51,292.1ZM406,269.55,465.21,291l15.55-43-59.22-21.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,261.26s-4.88,2.53-5.65,2.73-11.3-1.17-12.28-.78-3.89,2.14-5.45,2.53-1,2.92,1,3.51,6.82-.78,6.82-.78l1.36,1.56s-4.09,11.49-3.11,12.46,1.75,1.95,2.72,1.56,2.73-1,2.73-1l5.46,2.14c1,.39,4.28.59,5.06.2a7.51,7.51,0,0,0,2.34-2.54c.78-1.17,4.09-10.71,4.09-10.71l1.36-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.84,286.12a12.21,12.21,0,0,1-3.51-.44l-5.28-2.07c-.46.16-1.76.6-2.53.91-1.17.47-2.08-.46-2.95-1.35l-.32-.32c-1-1,1-7.39,2.9-12.72l-1-1.1c-1.13.3-5,1.23-6.79.69a3,3,0,0,1-2.22-2.83,1.64,1.64,0,0,1,1.27-1.64,22.16,22.16,0,0,0,3.76-1.7c.68-.36,1.27-.66,1.63-.81.57-.23,2.73-.07,7.67.4,2,.2,4.33.41,4.68.36.51-.13,3.66-1.72,5.52-2.68a.5.5,0,0,1,.61.11l6.43,7.4a.5.5,0,0,1,.09.51l-1.36,3.51c-.34,1-3.35,9.62-4.14,10.81a7.64,7.64,0,0,1-2.54,2.7A5.11,5.11,0,0,1,444.84,286.12Zm-8.78-3.54a.52.52,0,0,1,.18,0l5.46,2.15a11.16,11.16,0,0,0,4.66.21,7.45,7.45,0,0,0,2.14-2.36c.55-.82,2.71-6.79,4-10.61l1.26-3.24-6-6.88c-1.2.62-4.7,2.41-5.41,2.59a29.89,29.89,0,0,1-5-.33,56.69,56.69,0,0,0-7.22-.47c-.31.13-.87.42-1.52.76a21.71,21.71,0,0,1-4,1.79.66.66,0,0,0-.51.69,2.05,2.05,0,0,0,1.51,1.86c1.48.44,5.22-.42,6.54-.78a.48.48,0,0,1,.51.15l1.36,1.56a.46.46,0,0,1,.09.49c-1.82,5.14-3.57,11.19-3.2,12l.3.29c.81.83,1.33,1.32,1.86,1.12,1-.39,2.68-1,2.75-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.32,173.59s-4.28,1.56-5.65,11.89,1.95,18.5,3.9,21.43,18,25.06,18,25.06-1.95,1.75-1.75,2.73l.19,1-25.81,25,9.93,10.13s31.74-15.23,39.26-21.49c6-5,9.16-15.39,9-17.53s-20.94-46.89-24.06-52.54-6.62-9.15-9.35-9.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.15,271.3a.5.5,0,0,1-.35-.14L444.86,261a.54.54,0,0,1-.14-.36.47.47,0,0,1,.15-.35l25.62-24.82-.14-.7c-.2-1,.91-2.24,1.58-2.89-2.08-2.87-16-22-17.78-24.73-2-3-5.35-11.33-4-21.77s5.78-12.22,6-12.29a.5.5,0,0,1,.64.3.5.5,0,0,1-.29.64c-.07,0-4,1.7-5.33,11.48-1.34,10.15,1.91,18.23,3.81,21.09s17.86,24.83,18,25.05a.49.49,0,0,1-.07.66c-.83.74-1.68,1.85-1.6,2.26l.19,1a.49.49,0,0,1-.14.46l-25.45,24.65,9.33,9.52c3.36-1.63,31.85-15.46,38.83-21.27,6-5,9-15.23,8.78-17.11-.24-2.16-20.84-46.6-24-52.33-2.87-5.21-6.34-8.93-9.05-9.7a.5.5,0,1,1,.28-1c3,.86,6.61,4.66,9.65,10.17,2.58,4.68,23.89,50.21,24.12,52.73s-3.06,12.9-9.14,18c-7.48,6.24-38.06,20.94-39.36,21.57A.54.54,0,0,1,455.15,271.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.79,235.39a.5.5,0,0,1-.49-.38.49.49,0,0,1,.36-.6c5.92-1.5,15.95-3.71,16.58-1.61a.5.5,0,0,1-1,.29c-.73-.79-8.55.56-15.37,2.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.49,231.89a.54.54,0,0,1-.21,0s-4.58-2.07-8.27-1.33a.5.5,0,1,1-.19-1c4-.8,8.68,1.31,8.88,1.4a.49.49,0,0,1,.24.66A.49.49,0,0,1,491.49,231.89Z",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.5,238.06a.5.5,0,0,1-.33-.88l3.15-2.7a17.84,17.84,0,0,0-.56-3.26,1.35,1.35,0,0,1,.24-1.36,2.44,2.44,0,0,1,1.73-.6c-3.13-4.56-17.32-25.32-18.9-29.4-1.75-4.49-2.62-13.94-2.66-14.34a.5.5,0,0,1,1-.09c0,.1.89,9.7,2.59,14.07s19.2,29.79,19.38,30.05a.48.48,0,0,1,0,.55.5.5,0,0,1-.5.23c-.61-.1-1.63-.11-1.91.2,0,0-.1.12,0,.41a19.57,19.57,0,0,1,.62,3.73.52.52,0,0,1-.18.41l-3.34,2.86A.49.49,0,0,1,467.5,238.06Z",
    style: {
      fill: "#a1a1a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,229.09s-7.41-4.09-9.77-5.83a5.45,5.45,0,0,0-5.52-.47,57,57,0,0,0-4.1,6.3c-.47.95,1,1.58,2.21,1.42s5.52-3,5.52-3l5.36,4.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.55,232.27a.55.55,0,0,1-.32-.1l-5.07-4c-1.06.69-4.25,2.72-5.43,2.87a2.94,2.94,0,0,1-2.63-.86,1.2,1.2,0,0,1-.08-1.28c.32-.65,3.59-6.05,4.26-6.5a5.89,5.89,0,0,1,6.09.49c2.32,1.69,9.65,5.76,9.72,5.8a.5.5,0,0,1,.2.68.5.5,0,0,1-.68.19c-.31-.17-7.46-4.13-9.83-5.86a4.93,4.93,0,0,0-4.94-.46,60.73,60.73,0,0,0-3.93,6.11c-.07.14,0,.2,0,.26a2,2,0,0,0,1.69.44c.83-.11,3.69-1.85,5.3-2.92a.5.5,0,0,1,.59,0l5.36,4.25a.5.5,0,0,1,.08.7A.49.49,0,0,1,367.55,232.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.28,378.14H675.69l-2.19-13.75a29.12,29.12,0,0,1-6.71-2.79l-11.28,8.19-8.2-8.2,8.19-11.27a30.29,30.29,0,0,1-2.79-6.72L639,341.42v-11.6l13.75-2.18a30.29,30.29,0,0,1,2.79-6.72l-8.19-11.27,8.2-8.2,11.28,8.19a29.56,29.56,0,0,1,6.71-2.79l2.19-13.75h11.59l2.18,13.75a29.64,29.64,0,0,1,6.72,2.79l11.27-8.19,8.2,8.2-8.19,11.27a29.37,29.37,0,0,1,2.79,6.72L724,329.82v11.6l-13.76,2.18a29.37,29.37,0,0,1-2.79,6.72l8.19,11.27-8.2,8.2-11.27-8.19a29.19,29.19,0,0,1-6.72,2.79Zm-10.74-1h9.89l2.15-13.55.31-.08a28.51,28.51,0,0,0,7.07-2.94l.28-.16,11.11,8.07,7-7-8.07-11.11.17-.28a28.87,28.87,0,0,0,2.93-7.07l.09-.32L723,340.56v-9.88l-13.55-2.15-.09-.32a28.87,28.87,0,0,0-2.93-7.07l-.17-.28,8.07-11.11-7-7-11.11,8.07-.28-.16a28.2,28.2,0,0,0-7.07-2.94l-.31-.08-2.15-13.55h-9.89l-2.15,13.55-.31.08a28.42,28.42,0,0,0-7.08,2.94l-.28.16-11.1-8.07-7,7,8.06,11.11-.16.28a28.9,28.9,0,0,0-2.94,7.07l-.08.32L640,330.68v9.88l13.55,2.15.08.32a28.9,28.9,0,0,0,2.94,7.07l.16.28-8.06,11.11,7,7,11.1-8.07.28.16a28.42,28.42,0,0,0,7.08,2.94l.31.08Zm4.94-24.43a17.09,17.09,0,1,1,17.09-17.09A17.11,17.11,0,0,1,681.48,352.71Zm0-33.18a16.09,16.09,0,1,0,16.09,16.09A16.11,16.11,0,0,0,681.48,319.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.49,190.63h-10l-1.86-11.75a25,25,0,0,1-5.66-2.36l-9.63,7-7.09-7.08,7-9.64a24.53,24.53,0,0,1-2.35-5.66l-11.75-1.86v-10l11.75-1.86a24.79,24.79,0,0,1,2.35-5.67l-7-9.63,7.09-7.08,9.63,7a25.44,25.44,0,0,1,5.66-2.35l1.86-11.75h10l1.87,11.75A25.44,25.44,0,0,1,557,132l9.63-7,7.08,7.08-7,9.63a25.52,25.52,0,0,1,2.35,5.67l11.75,1.86v10l-11.75,1.86a25.44,25.44,0,0,1-2.35,5.66l7,9.64-7.08,7.08-9.63-7a25,25,0,0,1-5.66,2.36Zm-9.16-1h8.31l1.83-11.55.32-.08a24.65,24.65,0,0,0,6-2.5l.28-.17,9.47,6.88,5.87-5.88-6.87-9.46.16-.29a24.49,24.49,0,0,0,2.5-6l.08-.32,11.55-1.83v-8.31l-11.55-1.83-.08-.31a24.56,24.56,0,0,0-2.5-6l-.16-.28,6.87-9.47-5.87-5.87-9.47,6.87-.28-.16a24.65,24.65,0,0,0-6-2.5l-.32-.08-1.83-11.55h-8.31l-1.83,11.55-.32.08a24.49,24.49,0,0,0-6,2.5l-.29.16-9.46-6.87-5.88,5.87,6.88,9.47-.17.28a24.31,24.31,0,0,0-2.49,6l-.09.31-11.54,1.83v8.31l11.54,1.83.09.32a24.08,24.08,0,0,0,2.49,6l.17.29-6.88,9.46,5.88,5.88,9.46-6.88.29.17a24.49,24.49,0,0,0,6,2.5l.32.08Zm4.15-20.71a14.66,14.66,0,1,1,14.66-14.65A14.66,14.66,0,0,1,544.48,168.92Zm0-28.31a13.66,13.66,0,1,0,13.66,13.66A13.67,13.67,0,0,0,544.48,140.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,387.28H175l-1.38-8.71a18.94,18.94,0,0,1-4.06-1.69l-7.14,5.19-5.39-5.39,5.18-7.14a18.9,18.9,0,0,1-1.68-4.06l-8.71-1.38v-7.63l8.71-1.38a18.9,18.9,0,0,1,1.68-4.06l-5.18-7.14,5.39-5.39,7.14,5.18a18.9,18.9,0,0,1,4.06-1.68l1.38-8.71h7.63l1.38,8.71a18.9,18.9,0,0,1,4.06,1.68l7.14-5.18,5.39,5.39L195.45,351a18.94,18.94,0,0,1,1.69,4.06l8.71,1.38v7.63l-8.71,1.38a18.94,18.94,0,0,1-1.69,4.06l5.19,7.14-5.39,5.39-7.14-5.19a18.94,18.94,0,0,1-4.06,1.69Zm-6.77-1h5.91l1.35-8.51.32-.08a18,18,0,0,0,4.41-1.83l.28-.17,7,5.07,4.19-4.19-5.07-7,.17-.28a17.88,17.88,0,0,0,1.83-4.41l.08-.32,8.51-1.35v-5.92L196.34,356l-.08-.32a17.88,17.88,0,0,0-1.83-4.41l-.17-.28,5.07-7-4.19-4.18-7,5.06-.28-.16a17.88,17.88,0,0,0-4.41-1.83l-.32-.09-1.35-8.5H175.9l-1.35,8.5-.32.09a17.88,17.88,0,0,0-4.41,1.83l-.28.16-7-5.06L158.38,344l5.06,7-.16.28a17.88,17.88,0,0,0-1.83,4.41l-.09.32-8.5,1.34v5.92l8.5,1.35.09.32a17.88,17.88,0,0,0,1.83,4.41l.16.28-5.06,7,4.18,4.19,7-5.07.28.17a17.88,17.88,0,0,0,4.41,1.83l.32.08Zm2.95-15a11,11,0,1,1,11-11A11,11,0,0,1,178.85,371.24Zm0-20.92a10,10,0,1,0,10,10A10,10,0,0,0,178.85,350.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,128.4H90.3l-2-12.75a27.18,27.18,0,0,1-6.19-2.57l-10.45,7.59L64,113l7.59-10.45A27.37,27.37,0,0,1,69,96.4l-12.75-2V83.57l12.75-2a27.63,27.63,0,0,1,2.57-6.19L64,64.91l7.64-7.64,10.45,7.59a27.63,27.63,0,0,1,6.19-2.57l2-12.75h10.8l2,12.75a27.63,27.63,0,0,1,6.19,2.57l10.45-7.59,7.64,7.64-7.59,10.45a27.63,27.63,0,0,1,2.57,6.19l12.75,2v10.8l-12.75,2a27.56,27.56,0,0,1-2.57,6.18L127.4,113l-7.64,7.64-10.45-7.59a27.18,27.18,0,0,1-6.19,2.57Zm-9.95-1h9.1l2-12.55.31-.08a26.66,26.66,0,0,0,6.54-2.71l.28-.17,10.29,7.47,6.43-6.43-7.47-10.28.16-.29a26.53,26.53,0,0,0,2.72-6.54l.08-.31,12.55-2v-9.1l-12.55-2-.08-.32a26.69,26.69,0,0,0-2.72-6.54l-.16-.28L126.09,65l-6.43-6.44-10.29,7.47-.28-.16a26.69,26.69,0,0,0-6.54-2.72l-.31-.08-2-12.55h-9.1l-2,12.55-.31.08a26.69,26.69,0,0,0-6.54,2.72l-.28.16L71.74,58.58,65.31,65,72.78,75.3l-.17.28a26.66,26.66,0,0,0-2.71,6.54l-.08.32-12.55,2v9.1l12.55,2,.08.31a26.35,26.35,0,0,0,2.71,6.54l.17.29-7.47,10.28,6.43,6.43L82,111.89l.28.17a26.66,26.66,0,0,0,6.54,2.71l.31.08Zm4.55-22.56A15.87,15.87,0,1,1,111.57,89,15.89,15.89,0,0,1,95.7,104.84Zm0-30.74A14.87,14.87,0,1,0,110.57,89,14.89,14.89,0,0,0,95.7,74.1Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.6e084f662771d15d990e95feb6b411d1.svg";
export { ForwardRef as ReactComponent };